<div class="file-uploader" dir="rtl">
  <input type="file" #fileInput [accept]="acceptTypes" hidden (change)="onFileSelected($event)">

  <div class="upload-row">
    <span class="upload-icon" aria-hidden="true"><i class="fa fa-file-image-o"></i></span>
    <div class="upload-copy">
      <span class="upload-title">{{ selectedFile ? 'تغییر تصویر' : 'انتخاب تصویر' }}</span>
      <span class="upload-hint">{{ allowedFileTypes.join('، ') }} · حداکثر {{ maxFileSize / (1024 * 1024) | faNum }} مگابایت</span>
    </div>
    <button type="button" class="choose-button" (click)="fileInput.click()">انتخاب فایل</button>
  </div>

  <div *ngIf="selectedFile" class="selected-file">
    <i class="fa fa-check-circle" aria-hidden="true"></i>
    <span [title]="selectedFile.name">{{ selectedFile.name }}</span>
    <button type="button" class="remove-button" (click)="removeFile()" aria-label="حذف فایل انتخاب‌شده">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>
  <p *ngIf="errorMessage" class="upload-error" role="alert">{{ errorMessage | faNum }}</p>
</div>
